import type { ResponseData, gqlV2 } from '@vrplatform/data';
import type { IconDefinition } from '@vrplatform/icons';
import type {
  accountReservationRevRec_enum,
  recurringFeeType_enum,
} from '@vrplatform/graphql';
import type { AmountFilterNumberString } from '@vrplatform/ui-common';
import { useFormContext } from 'react-hook-form';
import type { FeeFlatFeeBasis } from './useFeeForm.utils';

type ApiFeeReponse = ResponseData<'get:/recurring-fees/{id}'>;

export type FeeFormInputs = {
  id: string | undefined;
  title: string;
  rate: number; // either superbasispoints or centTotal
  revenueRecognition: accountReservationRevRec_enum;
  rateType?: NonNullable<ApiFeeReponse['rateType']>;
  flatFeeBasis?: FeeFlatFeeBasis;
  creditParty: gqlV2.party_enum;
  debitParty: gqlV2.party_enum;
  creditAccountId: string;
  debitAccountId: string;
  taxRateId: string | null;
  taxRateBehavior: NonNullable<ApiFeeReponse['taxBehavior']> | null;
  bookingChannelsFilter: 'all-channels' | string[];
  statusFilter: NonNullable<ApiFeeReponse['statusFilter']> | null;
  accountTotalConditions: AmountFilterNumberString | null;
  linkedAccountIds: string[];
  type: recurringFeeType_enum;
};

type Extract<T, U extends T> = T extends U ? T : never;

export const DEFAULT_FEE_ICON: FeeIcon = 'PercentageIcon';

export type FeeIcon = Extract<
  IconDefinition,
  | 'BedIcon'
  | 'HomeIcon'
  | 'OfficeIcon'
  | 'PercentageIcon'
  | 'StripeIcon'
  | 'BookingComIcon'
  | 'Ironing3Icon'
  | 'GardenCartIcon'
  | 'PoolIcon'
  | 'TractorIcon'
  | 'PaintIcon'
  | 'WashMachineIcon'
  | 'GrillIcon'
>;

export type FeeFormInputsBookingChannelsFilter = {
  _in?: string[];
  _nin?: string[];
};

export const useFeeForm = () => useFormContext<FeeFormInputs>();
